import React from "react";
import { Route, Switch } from "react-router-dom";
import UploadFile from "./UploadFile";
import ReportList from "./Reports/ReportList";
import FileManagement from "./FileManagement/FileManagement";
import FileInfo from "./FileManagement/FileInfo";

const LiquidityV2 = () => {
  return (
    <Switch>
      <Route exact path="/liquidity-v2/upload" component={UploadFile} />
      <Route exact path="/liquidity-v2/reports" component={ReportList} />
      <Route exact path="/liquidity-v2/file-management" component={FileManagement} />
      <Route path="/liquidity-v2/file-info/:date/:file_name" component={FileInfo} />
      <Route exact path="/liquidity-v2" component={UploadFile} />
    </Switch>
  );
};

export default LiquidityV2;



// WEBPACK FOOTER //
// src/pages/LiquidityV2/index.js